module.exports = __webpack_public_path__ + "img/bg1.70fa013d.png";